export default __webpack_public_path__ + "static/media/569.4ae0b17e.jpg";